/* eslint-disable no-console */
const devPrint = (...args) => {
  if (process.env.REACT_APP_AMB !== 'prod') {
    // console.log(...args);
  }
};

export default devPrint;
